import React from 'react';
import { Loader2 } from 'lucide-react';

/**
 * The one button. House rule: square buttons with rounded edges only
 * (rounded-md), never pills or circles.
 */
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger' | 'ghost';
  size?: 'sm' | 'md';
  busy?: boolean;
}

const VARIANT: Record<NonNullable<ButtonProps['variant']>, string> = {
  primary:   'bg-indigo-600 hover:bg-indigo-700 text-white border border-transparent',
  secondary: 'bg-white hover:bg-stone-50 text-stone-700 border border-stone-300',
  danger:    'bg-rose-600 hover:bg-rose-700 text-white border border-transparent',
  ghost:     'bg-transparent hover:bg-stone-100 text-stone-600 border border-transparent',
};

export const Button: React.FC<ButtonProps> = ({
  variant = 'secondary', size = 'md', busy = false, disabled, children, className = '', ...rest
}) => (
  <button
    {...rest}
    disabled={disabled || busy}
    className={[
      'inline-flex items-center justify-center gap-1.5 rounded-md font-semibold transition-colors',
      'focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-400',
      'disabled:opacity-50 disabled:cursor-not-allowed',
      size === 'sm' ? 'h-8 px-2.5 text-[12px]' : 'h-9 px-3.5 text-[13px]',
      VARIANT[variant],
      className,
    ].join(' ')}
  >
    {busy && <Loader2 className="w-3.5 h-3.5 animate-spin" />}
    {children}
  </button>
);
